import React from "react";
import {Box, Button, Column, Columns, Title} from "@allxsmith/bestax-bulma";
import Nav from "./Nav";
import {Link} from "react-router-dom";


export default function AllDropDownLinks(props){

    return (
        <div>
            <Nav/>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Part Links</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/partorders"}>Part Orders</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/parthistory"}>Part History</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/partlookup"}>Part Stock</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/parts"}>Part Expenses</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/labelprinter"}>Label Printer</Link>
                        </Button>
                    </Column>
                </Columns>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Invoicing</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/invoicing"}>Workshop Invoicing</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/invoices?activeView=movement"}>Movement Invoicing</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/invoices?activeView=sales"}>Vehicle Sales Invoicing</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/invoices?activeView=order"}>Parts Invoicing</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/invoices/activeView=hire"}>Hire Invoicing</Link>
                        </Button>
                    </Column>
                </Columns>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Vehicles</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/vehicles"}>Vehicles</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/keys"}>Keys</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/trackers"}>Vehicle Trackers</Link>
                        </Button>
                    </Column>
                    <Column></Column>
                    <Column></Column>
                </Columns>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Contacts</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/contacts"}>All Contacts</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/contacts?type=CC"}>Customers</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/contacts?type=SP"}>Suppliers</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/accountbalance"}>Customer Account Balance</Link>
                        </Button>
                    </Column>
                    <Column></Column>
                </Columns>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Title>Transactions</Title>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/po"}>Workshop Expenses</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/fixedexpense"}>Fixed Expenses</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/expenses"}>All Expenses</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/vanpartsexpenses"}>Van Parts Expenses</Link>
                            <Link to={"/vanpartsincome"}>Van Parts Income</Link>
                        </Button>
                    </Column>
                    <Column>
                        <Button
                            isFullWidth={true}
                            color={"info"}
                        >
                            <Link to={"/income"}>All Income</Link>
                        </Button>
                    </Column>
                    <Column></Column>
                </Columns>
            </Box>
            {/*<Box>*/}
            {/*    <Columns>*/}
            {/*        <Columns.Column>*/}
            {/*            <Heading>Payments</Heading>*/}
            {/*        </Columns.Column>*/}
            {/*    </Columns>*/}
            {/*    <Columns>*/}
            {/*        <Columns.Column>*/}
            {/*            <Button*/}
            {/*                color={"info"}*/}
            {/*                onClick={() => {push("/payments")}}*/}
            {/*                fullwidth*/}
            {/*            >*/}
            {/*                Sale Payments*/}
            {/*            </Button>*/}
            {/*        </Columns.Column>*/}
            {/*        <Columns.Column>*/}
            {/*            <Button*/}
            {/*                color={"info"}*/}
            {/*                onClick={() => {push("/recurringpayments")}}*/}
            {/*                fullwidth*/}
            {/*            >*/}
            {/*                Recurring Payments*/}
            {/*            </Button>*/}
            {/*        </Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*        <Columns.Column></Columns.Column>*/}
            {/*    </Columns>*/}
            {/*</Box>*/}
        </div>
    );

}